import { createAsyncThunk } from "@reduxjs/toolkit";
import { PossessionType } from "../../../client/services";
import { toastHandler } from "../../../utils/toastHandler";
import { FindPossessionType, GetPossessionType } from "./interface";

export const findSelectPossessionType = createAsyncThunk(
  "selectPossessionType/findSelectPossessionType",
  async (values: FindPossessionType, { rejectWithValue }) => {
    try {
      const response = await PossessionType.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectPossessionType = createAsyncThunk(
  "selectPossessionType/searchSelectPossessionType",
  async (values: FindPossessionType, { rejectWithValue }) => {
    try {
      const response = await PossessionType.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);


export const getSelectPossessionType = createAsyncThunk(
  'selectPossessionType/getSelectPossessionType',
  async ({ id }: GetPossessionType, { rejectWithValue }) => {
    try {
      const response = await PossessionType.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
